<script>
export default {
    props: {
        type: {
            type: String,
            required: true
        }
    },
    created() {
        this.dateStart = this.moment(this.$laravel.training.date_start)
        this.dateEnd = this.moment(this.$laravel.training.date_end)
        this.filters.month = this.defaultMonth
    },
    computed: {
        currentSelectedMonth() {
            return this.filters.month === null ? this.defaultMonth : this.filters.month
        },
        defaultMonth() {
            let current = this.moment()

            if (current.isBetween(this.dateStart, this.dateEnd, 'month'))
            {
                current.subtract(1, 'months')

                if (current.isSameOrBefore(this.dateStart, 'month')) {
                    return current
                } else if (current.isSameOrAfter(this.dateEnd, 'month')) {
                    return this.dateEnd
                }

                return current
            } else if (current.isSameOrBefore(this.dateStart, 'month')) {
                return this.dateStart
            }

            return this.dateEnd
        }
    },
    data: () => ({
        filters: {
            month: null
        },
        dateStart: null,
        dateEnd: null,
        breTotal: 0,
        bprTotal: 0,
        softTotal: 0
    }),
    methods: {
        onChange(date, dateString) {
            this.filters.month = date
        },
        breChange(total){
            this.breTotal = total
        },
        bprChange(total){
            this.bprTotal = total
        },
        softChange(total){
            this.softTotal = parseFloat(total)
        }
    }
}
</script>

<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false"
            :title="`BUSINESS PERFORMANCE : LAPORAN REALISASI TARGET BULAN`">
            <common-user-header />
        </a-page-header>

        <div style="margin: 20px 0;" class="text-right">
            <a-month-picker format="MMM YYYY" :defaultValue="defaultMonth" v-model="filters.month" @change="onChange" />
        </div>

        <summary-prf-imp-business
            :type="type"
            aspect="BRE"
            catCode="PRF-BRE-FIN"
            title="RESULT"
            :month="currentSelectedMonth"
            @breTotal="breChange"
            style="margin-bottom: 24px" />

        <summary-prf-imp-business
            :type="type"
            aspect="BPR"
            catCode="PRF-BPR-BUI"
            title="PROCESS"
            :month="currentSelectedMonth"
            @bprTotal="bprChange"
            style="margin-bottom: 24px" />

        <summary-prf-soft-competency :month="currentSelectedMonth" @softTotal="softChange" />

        <kpi-footer-summary v-if="type == 'SUM-KPI'" style="margin-top: 24px" :breTotal="breTotal" :bprTotal="bprTotal" :softTotal="softTotal" />
    </div>
</template>
